import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { config } from './config';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';

@Feature()
export class ClearFeature extends BaseToolbarFeature {
    id = config.id;
    config = config;
    constructor() {
        super();
    }

    public onClick() {
        const appService = AppServiceProvider.getInstance().getAppServices() as IEditorAppServices;
        appService.editableServiceLayer?.clearFormatManager.executeClear();
        this.twdReport();
    }
}
